/* eslint-disable import/no-unused-modules */

import EVENTS from "../constants/events";
import generateEventPair from "../helpers/generateEventPair";

export const {
  dispatcher: dispatchTourRatingAdded,
  responder: respondToTourRatingAdded
} = generateEventPair({
  eventName: EVENTS.RATING_ADDED,
  signatureParams: ["listingId", "listingType"]
});
